export default __webpack_public_path__ + "static/portfolio-banner-75b4b2226fdfd974ec816d15aafe162d.jpg";